import * as React from 'react';

import Component from './View';
import { ViewProps } from './model';

export type { ViewProps };

/**
 * Unit component to create custom ones.
 */
export const View: React.FC<ViewProps> = (props) => {
	return <Component {...props} />;
};
